import { isNil, omitBy } from 'lodash';
import quotation from './quotation';

const response = (data: any) => {
  return omitBy(
    {
      ...data,
      quotations: data.quotations?.map(quotation),
    },
    isNil,
  );
};

export default response;
